import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Authentication } from '../../services/authentication.service';
import { ErrorHandlingService } from '../../services/error-handling.service';

@Component({
  standalone: false,
  selector: 'app-microsoft-callback',
  template: '',
})
export class MicrosoftCallbackComponent implements OnInit {
  access_token;
  token_type;
  expires_in;
  scope;
  state;
  constructor(
    private authService: Authentication,
    private route: ActivatedRoute,
    private ngxLoader: NgxUiLoaderService,
    private errorHandlingService: ErrorHandlingService,
  ) {}

  ngOnInit(): void {
    this.route.snapshot.fragment.split('&').forEach((e) => {
      const s = e.split('=');

      this[s[0]] = s[1];
    });

    this.callback();
  }

  callback() {
    const query = `access_token=${this.access_token}&token_type=${this.token_type}&expires_in=${this.expires_in}&scope=${this.scope}&state=${this.state}`;

    this.authService.microsoftLoginCallback(query).subscribe(
      (data: any) => {
        if (data && data.body) {
          location.href = data.body;
        }
      },
      (error) => {
        this.ngxLoader.stop();
        this.errorHandlingService.handleError(error, error.url);
      },
    );
  }
}
